import React from 'react';
import { 
  Zap,
  Radio,
  ClipboardCheck,
  GraduationCap,
  Shield,
  Wrench,
  FileText,
  AlertTriangle
} from 'lucide-react';
import ServiceCard from '../components/ServiceCard';
import { CTASection } from '../components/sections';

const SERVICES = [
  {
    id: 'fiber-splicing',
    icon: Zap,
    title: 'Fiber Splicing',
    description: 'Professional splicing services for FTTH, backbone, and enterprise networks.',
    color: '#3b82f6',
    capabilities: [
      { icon: Wrench, text: 'Fusion splicing' },
      { icon: Wrench, text: 'Ribbon & loose-tube splicing' },
      { icon: ClipboardCheck, text: 'OTDR testing' },
      { icon: ClipboardCheck, text: 'Power meter testing' },
      { icon: Shield, text: 'Enclosure installation' },
      { icon: AlertTriangle, text: 'Emergency restoration' }
    ]
  },
  {
    id: 'tower-deployment',
    icon: Radio,
    title: 'Tower Site Deployment',
    description: 'Turnkey installation and upgrades for basic tower infrastructure.',
    color: '#10b981',
    capabilities: [
      { icon: Wrench, text: 'Tower climbing & equipment mounting' },
      { icon: Wrench, text: 'Antenna and bracket installation' },
      { icon: Shield, text: 'Grounding and power integration' },
      { icon: Wrench, text: 'Cable routing and weatherproofing' },
      { icon: FileText, text: 'Site audits and closeout documentation' }
    ]
  },
  {
    id: 'field-verification',
    icon: ClipboardCheck,
    title: 'Field Verification & Quality Control',
    description: 'Independent verification to ensure your infrastructure meets standards.',
    color: '#f59e0b',
    capabilities: [
      { icon: ClipboardCheck, text: 'Site inspections' },
      { icon: ClipboardCheck, text: 'Fiber certification' },
      { icon: Shield, text: 'Tower safety checks' },
      { icon: FileText, text: 'Documentation & reporting' }
    ]
  },
  {
    id: 'education-seminars',
    icon: GraduationCap,
    title: 'Education Seminars',
    description: 'Telecom fundamentals for students and academic institutions.',
    color: '#8b5cf6',
    capabilities: [
      { icon: GraduationCap, text: 'Intro to fiber optics' },
      { icon: GraduationCap, text: 'How networks work' },
      { icon: Wrench, text: 'Infrastructure demonstrations' },
      { icon: GraduationCap, text: 'Career guidance' },
      { icon: FileText, text: 'Custom seminars for schools and universities' }
    ]
  }
];

const ServicesHero = () => (
  <section className="relative py-20 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-[#0a1628] via-[#0f1d32] to-[#162544]" />
    <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#3b82f6]/10 rounded-full blur-3xl" />
    
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#f1f5f9] mb-6 animate-fade-in-up">
          Our Services
        </h1>
        <p className="text-xl text-[#94a3b8] leading-relaxed animate-fade-in-up delay-100">
          From precision fiber splicing to comprehensive tower deployment, we deliver 
          professional telecommunications field services with a focus on quality and safety.
        </p>
      </div>
    </div>
  </section>
);

const ServicesList = () => (
  <section className="py-20 bg-[#0f1d32]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="space-y-16">
        {SERVICES.map((service, index) => (
          <ServiceCard 
            key={service.id} 
            service={service} 
            isReversed={index % 2 === 1} 
          />
        ))}
      </div>
    </div>
  </section>
);

const Services = () => {
  return (
    <div className="min-h-screen bg-[#0a1628]">
      <ServicesHero />
      <ServicesList />
      <CTASection
        title="Need Our Services?"
        description="Contact us today to discuss your project requirements and get a customized solution."
        actionLabel="Request a Quote"
        actionTo="/contact"
      />
    </div>
  );
};

export default Services;
